// extracted by mini-css-extract-plugin
module.exports = {"cls1":"logo_cls1__2PlFx","fill":"logo_fill__1q2Jb","cls6":"logo_cls6__8LhJ5"};